import { render, staticRenderFns } from "./commonRouteInfoAdd.vue?vue&type=template&id=fc2a8984&scoped=true"
import script from "./commonRouteInfoAdd.vue?vue&type=script&lang=js"
export * from "./commonRouteInfoAdd.vue?vue&type=script&lang=js"
import style0 from "./commonRouteInfoAdd.vue?vue&type=style&index=0&id=fc2a8984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2a8984",
  null
  
)

export default component.exports